import{styled as e,css as a,variants as r,modifier as o}from"@lokalise/styled";import"react";import"../../foundations/icons/styles.js";import{LoadingSign as t}from"../../foundations/icons/LoadingSign/index.js";import{smallInputHeight as n,inputHeight as i}from"../../utils/styles/inputStyle.js";import"../../utils/styles/link.js";import"../../utils/styles/oneLineEllipsis.js";import"../../utils/styles/outlineStyle.js";import{radius as p,transitionTime as c,fontFamily as l,spacing as s,color as d}from"../../utils/theme/index.js";import{Pressable as y}from"../Pressable/index.js";const b=e=>o((e=>{let{isLoading:a}=e;return!a}),a`
			&:disabled {
				${e}
			}
		`),u=e=>a`
	// Idle
	${e.idle};

	// Hover
	&:hover:not([disabled]):not([aria-expanded='true']) {
		${e.hover};
	}

	// Pressed
	&:active:not([disabled]):not([aria-expanded='true']),
	&:focus:active:not([disabled]):not([aria-expanded='true']) {
		${e.active};
	}

	// Activated
	${o("active",e.active)};

	// Disabled
	${b(e.disabled)}
`,m=e(y).withConfig({displayName:"Button__Container",componentId:"sc-wyblvi-0"})(["display:inline-flex;align-items:center;background-color:transparent;border:1px solid transparent;text-decoration:none;vertical-align:middle;border-radius:",";cursor:pointer;position:relative;transition:all ",";box-sizing:border-box;font-family:",";",";"," ",";",";"],p("md"),c(),l("default"),b(a`
			cursor: not-allowed;
		`),r("size",{xs:a`
			font-size: 11px;
			padding: ${s(0,2)};
			height: 20px;
			line-height: 12px;
		`,sm:a`
			font-size: 12px;
			padding: ${s(0,3)};
			height: ${n}px;
			line-height: 12px;
		`,md:a`
			font-size: 14px;
			padding: ${s(0,3)};
			height: ${i}px;
			line-height: 14px;
		`,lg:a`
			font-size: 18px;
			padding: ${s(0,4)};
			height: 45px;
			line-height: 18px;
		`}),r("appearance",{accent:u({idle:a`
				--button-appearance-primary-color: ${d("interactive.primary.idle")};
				--button-appearance-secondary-color: ${d("content.buttonText1")};
			`,hover:a`
				--button-appearance-primary-color: ${d("interactive.primary.hover")};
			`,active:a`
				--button-appearance-primary-color: ${d("interactive.primary.pressed")};
			`,disabled:a`
				--button-appearance-secondary-color: ${d("interactive.primary.disabled")};
				--button-appearance-primary-color: ${d("surface.secondary")};
			`}),danger:u({idle:a`
				--button-appearance-primary-color: ${d("interactive.red.idle")};
				--button-appearance-secondary-color: ${d("content.buttonText1")};
			`,hover:a`
				--button-appearance-primary-color: ${d("interactive.red.hover")};
			`,active:a`
				--button-appearance-primary-color: ${d("interactive.red.pressed")};
			`,disabled:a`
				--button-appearance-secondary-color: ${d("interactive.red.disabled")};
				--button-appearance-primary-color: ${d("surface.secondary")};
			`}),warning:u({idle:a`
				--button-appearance-primary-color: ${d("interactive.yellow.idle")};
				--button-appearance-secondary-color: ${d("content.buttonText2")};
			`,hover:a`
				--button-appearance-primary-color: ${d("interactive.yellow.hover")};
			`,active:a`
				--button-appearance-primary-color: ${d("interactive.yellow.pressed")};
			`,disabled:a`
				--button-appearance-secondary-color: ${d("interactive.yellow.disabled")};
				--button-appearance-primary-color: ${d("surface.secondary")};
			`})}),r("variant",{primary:a`
			background-color: var(--button-appearance-primary-color);
			color: var(--button-appearance-secondary-color);

			${b(a`
					border: 1px solid var(--button-appearance-secondary-color);
				`)}
		`,secondary:a`
			background-color: transparent;
			border-width: 1px;
			border-color: var(--button-appearance-primary-color);
			color: var(--button-appearance-primary-color);

			${b(a`
					color: var(--button-appearance-secondary-color);
					border: 1px solid var(--button-appearance-secondary-color);
				`)}
		`,tertiary:a`
			background-color: transparent;
			border-color: transparent;
			color: var(--button-appearance-primary-color);

			${b(a`
					color: var(--button-appearance-secondary-color);
				`)}
		`})),v=e.span.withConfig({displayName:"Button__Content",componentId:"sc-wyblvi-1"})(["display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;width:100%;"," ",""],r("size",{xs:a`
			gap: ${s(1)};
		`,sm:a`
			gap: ${s(2)};
		`,md:a`
			gap: ${s(2)};
		`,lg:a`
			gap: ${s(2)};
		`}),o("isHidden",a`
			opacity: 0;
		`)),g=e.span.withConfig({displayName:"Button__Text",componentId:"sc-wyblvi-2"})(["position:relative;align-items:center;display:inline-flex;white-space:nowrap;",""],r("size",{xs:a`
			top: 0;
		`,sm:a`
			top: 0;
		`,md:a`
			top: 0;
		`,lg:a`
			top: -1px; // Make text visually centered
		`})),x=e(t).withConfig({displayName:"Button__StyledLoadingSign",componentId:"sc-wyblvi-3"})(["font-size:1.3em;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]);export{m as Container,v as Content,x as StyledLoadingSign,g as Text,u as defineAppearance};
//# sourceMappingURL=styles.js.map
